/* STEIN & VOSS — wishlist toggle (localStorage, idempotent) */
(function () {
  'use strict';
  if (window.__svWishlistInitialized) return;
  window.__svWishlistInitialized = true;

  var STORAGE_KEY = 'sv-wishlist';

  function getIds() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function setIds(ids) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch (e) {
      /* storage unavailable — wishlist stays session-only */
    }
  }

  function syncButtons() {
    var ids = getIds();
    var buttons = document.querySelectorAll('[data-sv-wishlist]');
    Array.prototype.forEach.call(buttons, function (btn) {
      var active = ids.indexOf(btn.getAttribute('data-product-id')) !== -1;
      btn.classList.toggle('sv-wishlist--active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-sv-wishlist]') : null;
    if (!btn) return;
    event.preventDefault();

    var id = btn.getAttribute('data-product-id');
    var ids = getIds();
    var index = ids.indexOf(id);
    if (index === -1) {
      ids.push(id);
    } else {
      ids.splice(index, 1);
    }
    setIds(ids);
    syncButtons();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncButtons);
  } else {
    syncButtons();
  }
})();
